import React from 'react';
import type { LinkElementProps } from '../internalComponents/RCFavoriteCard/RCFavoriteCard';
import { RCFavoriteCard } from '../internalComponents/RCFavoriteCard/RCFavoriteCard';
import RCSavedSearchThumbnailFallbackImage from '../../images/componentHelpers/RCSavedSearchThumbnailFallback.svg';

interface RCSavedSearchCardProps {
  /** Any additional content that sits near the bottom of the card. E.g. "View Search" link */
  additionalContent: React.ReactElement;

  /** The link element (e.g. CoreLink)
   * Example: `linkElement={(children) => (<CoreLink to="/whatever/url/">{children}</CoreLink>)}`
   * Including this makes the whole card clickable
  */
  linkElement: (children: React.ReactNode) => React.ReactElement<LinkElementProps>;

  /** Sits adjacent to the watchButtonElement inside the card and should be the same size/shape. Designed for `<RCIconButton>` */
  secondaryAction?: React.ReactElement;

  /** The small string of text right below title in gray */
  subtitle: string;

  /** URL to a listing image to represent the saved search */
  thumbnailURL: string;

  /** The main title text of the card */
  title: string;

  /** Enabling this will allow the card to grow in height to fill its parent. Helpful for when inside a grid.
   * Disable when only showing on card in a given UI */
  verticalStretch?: boolean;

  /** The main element that renders a watch/favorite button. Designed to support `<RCFavoriteButton>` */
  watchButtonElement?: React.ReactElement;
}

export function RCSavedSearchCard({
  additionalContent,
  linkElement,
  secondaryAction = undefined,
  subtitle,
  thumbnailURL,
  title,
  verticalStretch = true,
  watchButtonElement = undefined,
}: RCSavedSearchCardProps) {
  return (
    <RCFavoriteCard
      additionalContent={additionalContent}
      linkElement={linkElement}
      primaryAction={watchButtonElement}
      secondaryAction={secondaryAction}
      subtitle={subtitle}
      thumbnailURL={thumbnailURL || RCSavedSearchThumbnailFallbackImage}
      title={title}
      type="search"
      verticalStretch={verticalStretch}
    />
  );
}
